import React, { useState, createContext } from "react";

import currentUserToMembership from "../../helpers/userToMembership";
import { transformKeysToUnderscore } from "../../helpers/snakeCaseKeys";
import { getItem } from "../../lib/session-storage";

export const OrganizationContext = createContext();

// A MUM user's selected account is persisted to sessionStorage under `mumHost`
// (shared same-origin with enterprise) so the selection survives navigation
// across the host/enterprise boundary. Restore it here, before first render,
// so the dropdown and any account-scoped queries start on the right account
// with no My Account -> parent flicker. Falls back to the logged-in user if
// nothing is stored or the stored value is malformed.
function restoreSelectedUser(fallbackUser) {
  const stored = getItem('mumHost');
  if (!stored) return fallbackUser;

  try {
    return transformKeysToUnderscore(JSON.parse(stored), { 'image_url': 'image_url_50' });
  } catch (error) {
    return fallbackUser;
  }
}

export function withOrganization(Component) {
  return (props) => {
    const [ selectedUser, setSelectedUser ] = useState(() => restoreSelectedUser(props.user));
    const [ selectedMembership, setSelectedMembership ] = useState(currentUserToMembership(props.user))

    return (
      <OrganizationContext.Provider value={{selectedUser, setSelectedUser, selectedMembership, setSelectedMembership}}>
        <Component {...props} />
      </OrganizationContext.Provider>
    )
  };
}
